<template>
  <div class="main-content fasilitas">
    <section class="inner-header about-us">
      <div class="container pt-60 pb-70">
        <!-- Section Content -->
        <div class="section-content">
          <div class="row">
            <div class="col-md-12">
              <h2 class="title">Fasilitas</h2>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="fasilitas-containter">
      <div class="container">
        <div class="section-title text-center">
          <div class="row">
            <div class="col-md-12">
              <h2 class="text-uppercase mt-0 line-height-1">
                Fasilitas
                <span class="text-theme-colored">Rumah Sakit UII</span>
              </h2>
            </div>
          </div>
        </div>
        <div class="section-content mt-30">
          <i v-if="show_loading" class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
          <div v-else-if="facilities.length < 1" class="alert alert-danger">No data</div>
          <div class="row">
            <div
              :key="item.id"
              v-for="item in facilities"
              class="col-xs-12 col-sm-6 col-md-6 col-lg-4 mb-30"
            >
              <img
                v-bind:src="(JSON.parse(item.meta).meta_picture == null) ? 'http://placehold.it/200x200' : JSON.parse(item.meta).meta_picture"
                alt
                class="img-responsive"
              />
              <h5 class="mt-15 mb-10 text-center">{{ item.title }}</h5>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show_loading: true,
      facilities: [],
    };
  },
  mounted() {
    let response = this.$store.dispatch("loadFacility");

    response
      .then((data) => {
        let status = data.status;
        if (status) {
          this.show_loading = false;
          this.facilities = data.data;
        }
      })
      .catch((err) => console.log(err));
  },
  methods: {},
  computed: {},
};
</script>


// WEBPACK FOOTER //
// src/pages/Fasilitas.vue